import React from 'react';
import { createPortal } from 'react-dom';
import MagicButton from 'components/MagicButton/MagicButton';
import { AssetUrls } from 'config/assets';
import './ConfirmMaintenanceModal.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ConfirmMaintenanceModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="confirm-maintenance-modal-overlay" onClick={onClose}>
      <div className="confirm-maintenance-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-maintenance-modal-header">
          <h2 className="confirm-maintenance-modal-title">Enable Maintenance Mode?</h2>
          <button className="confirm-maintenance-close-button" onClick={onClose}>
            <img
              src={AssetUrls.icons.dropdowns.close}
              alt="Close"
              style={{ width: 16, height: 16 }}
            />
          </button>
        </div>

        <div className="confirm-maintenance-modal-content">
          <p className="confirm-question">
            Are you sure you want to enable maintenance mode?
          </p>

          <div className="warning-box">
            ⚠️ <strong>Warning:</strong> This will prevent non-admin users from accessing the site.
          </div>

          <p className="info-text">
            Regular users will see a maintenance page instead of the normal site. You will still have full access as an admin.
          </p>

          <p className="info-text">
            You can disable maintenance mode at any time from the admin dashboard.
          </p>
        </div>

        <div className="confirm-maintenance-modal-footer">
          <MagicButton
            label="Cancel"
            color="grey"
            onPress={onClose}
            isDisabled={isLoading}
            fullWidth={false}
          />
          <MagicButton
            label={isLoading ? "Enabling..." : "Enable Maintenance Mode"}
            color="purple"
            onPress={onConfirm}
            isLoading={isLoading}
            isDisabled={isLoading}
            fullWidth={false}
          />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ConfirmMaintenanceModal;
